export default __webpack_public_path__ + "static/media/money-back@3x.f7e30305.png";